import { render, staticRenderFns } from "./doctorDetail.vue?vue&type=template&id=448849f7&scoped=true&"
import script from "./doctorDetail.vue?vue&type=script&lang=js&"
export * from "./doctorDetail.vue?vue&type=script&lang=js&"
import style0 from "./doctorDetail.vue?vue&type=style&index=0&id=448849f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448849f7",
  null
  
)

export default component.exports